const NotFoundPage = () => {
  return (
    <>
      <h1>Error 404</h1>
      <p>Resource Not Found</p>
    </>
  );
};

export default NotFoundPage;
